// 促销-产品详情页优惠信息
import ajax from '@/utils/ajax';

const header = '/web';
// 添加商品到购物
export const reqAddCart = (data) => ajax(`${header}/v1/cart`, data, 'POST');
// 获取购物车数量
export const reqCartCount = () => ajax(`${header}/v1/cart/count`);
// 获取购物车列表
export const reqCartList = () => ajax(`${header}/v1/cart`);
// 清除购物车失效商品
export const reqCleanAll = () => ajax(`${header}/v1/cart/clean/invalid/goods`);
// 删除购物车中的商品
export const reqDeleteGood = (data) => ajax(`${header}/v1/cart/${data}`, '', 'DELETE');
// 购物车列表修改规格（更新购物车中商品）
export const reqChangeGood = (data) => ajax(`${header}/v1/cart`, data, 'PUT');
// 批量获取套餐名称
export const reqPackageName = (data) => ajax(`${header}/v1/package/basic/info?packageIdList=${data}`);
